import { of } from 'rxjs';
var TypeListServiceStub = /** @class */ (function () {
    function TypeListServiceStub() {
    }
    TypeListServiceStub.prototype.getCitiesByPostalCode = function (postalCode, countryCode) {
        if (countryCode === void 0) { countryCode = 'ar'; }
        return of({
            cities: [{
                    name: 'Rosario',
                    stateCode: '',
                    stateDescription: '',
                    synonymous: ''
                }]
        });
    };
    return TypeListServiceStub;
}());
export { TypeListServiceStub };
